module.exports = __webpack_public_path__ + "resources/img/img-vormetric-encryption-en.1248e260749fc9af7404cc145eb43528.png";